module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-0998597788603af0eca6e0715757fed9.webp";